import { Helmet } from '@dr.pogodin/react-helmet';
import { Api } from 'src/api';
import {
  EmptyState,
  PageError,
  PageLoading,
  PageWrap,
  Stack,
  Text,
} from 'src/components';
import { Color } from 'src/constants';
import { Model } from 'src/models';

import { ProjectsClientCard, ProjectsTabs } from '../components';

export default function ProjectsPage() {
  const api =
    Api.CompanyProjectSummary.useReadCollectionProjectSummaryAsAgency();

  if (api.error) return <PageError {...api} />;
  const summaries = api.data?.['hydra:member'];
  if (!summaries) return <PageLoading />;

  const sorted = [...summaries].sort((a, b) =>
    Model.Company.compareCompanies(a.company, b.company)
  );

  return (
    <PageWrap background={Color.neutral5} limitWidth="small">
      <Helmet>
        <title>Projects</title>
      </Helmet>

      <Stack gap={1}>
        <Text typeface="headline" as="h1">
          Projects
        </Text>

        <ProjectsTabs selected="overview" />

        {sorted.length === 0 ? (
          <EmptyState
            title="No active projects"
            subtitle="Projects and service orders show up here as they open."
          />
        ) : (
          sorted.map((summary) => (
            <ProjectsClientCard
              key={summary.company['@id']}
              summary={summary}
              invalidate={api.invalidate}
            />
          ))
        )}
      </Stack>
    </PageWrap>
  );
}
